module.exports = __webpack_public_path__ + "static/pm2-4ed89e18743cabfc9f8e122394cf395b.png";